import type { NewsItem } from "@/types/content";

export const news: NewsItem[] = [
  {
    id: "family-ethics-drama-trend-2025",
    title: "从「家庭秘密」到「日常协商」：日本伦理剧近十年的叙事转向",
    date: "2025-10-12",
    category: "剧集观察",
    excerpt:
      "曾经依赖身世反转的伦理剧，正在把镜头转向餐桌、账单与深夜对话。这一转向背后，是观众对「可理解的复杂」的需求。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20a%20quiet%20Japanese%20dining%20room%20at%20dusk%20with%20a%20low%20wooden%20table%20and%20two%20empty%20cups%2C%20soft%20warm%20lamp%20light%2C%20deep%20navy%20shadows%2C%20cinematic%20muted%20tones%2C%20no%20text&width=800&height=450&seq=news-01&orientation=landscape",
    tags: ["剧集观察", "家庭伦理", "叙事"],
    content: [
      "过去十年，日本伦理题材剧集最明显的变化，并不是尺度，而是叙事重心的位移。身世反转、遗产争夺这类强情节装置逐渐退到背景，取而代之的是餐桌上的沉默、账单前的犹豫、以及深夜客厅里那段没说完的话。",
      "这种转向并非偶然。当观众对「秘密揭晓」的刺激产生疲劳，创作者必须找到一种更持久的张力来源。日常协商恰好提供了这种张力：它不需要坏人，只需要两个都有一点道理的人。",
      "《春分之后》是这一转向的典型样本。影片里没有出轨、没有暴力，唯一的冲突是夫妻对「共同生活」的理解不同。导演津岛和也把整部作品压缩在一天一夜里，让所有被搁置的问题缓慢浮出水面。",
      "与此同时，伦理剧对「制度」的关注明显增强。《静默的证词》讨论翻译的职业伦理，《借来的名字》讨论身份制度如何塑造人的尊严。个人的道德困境被放回结构之中，观众也不再被要求简单地站队。",
      "对创作者而言，这意味着一件事：伦理叙事的说服力，来自细节的准确度。一只缺口的碗、一句没说出口的谢谢，往往比一次激烈的争吵更能承载重量。",
    ],
  },
  {
    id: "white-porcelain-review",
    title: "《白瓷之隙》深度解析：裂缝不是失败，而是被看见的开始",
    date: "2025-09-26",
    category: "剧情解析",
    excerpt:
      "河濑一成用一只裂开的碗，完成了对三代人沉默的解剖。本文从器物、声音与空间三个维度拆解这部作品。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=editorial%20close%20up%20photograph%20of%20a%20cracked%20white%20ceramic%20bowl%20on%20a%20dark%20wooden%20table%20with%20soft%20side%20light%2C%20deep%20shadows%2C%20muted%20cream%20and%20navy%20tones%2C%20cinematic%20still%20life%2C%20no%20text&width=800&height=450&seq=news-02&orientation=landscape",
    tags: ["剧情解析", "白瓷之隙", "家庭伦理"],
    content: [
      "《白瓷之隙》开场的前三分钟没有一句台词。镜头从厨房的水槽移到木箱，再移到那只缺了口的白瓷碗上。导演河濑一成没有给裂缝特写，而是让它反复出现在画面边缘——这正是全片的叙事方法：不强调破损，只让你在日常生活里意识到它一直在那。",
      "器物在这部作品里承担了伦理载体的功能。碗是母亲留下的证据，也是家庭内部无法说出口的亏欠。三个子女围绕它的来历争执，实际上是在争夺「谁有资格解释过去」。",
      "声音设计同样值得注意。全片没有配乐，只有水声、碗碟碰撞与远处的电车。当一个家庭失去共同语言，环境声就成了唯一还在持续的关系证明。",
      "影片最克制的一幕发生在结尾：长女把碗重新放回木箱，却没有盖上盖子。这个动作没有伴随任何台词，但它同时拒绝了遗忘与和解——裂缝被保留，也被允许被看见。",
      "从这个意义上说，《白瓷之隙》讨论的不是原谅，而是共处。理解并不等于原谅，但理解是继续共同生活的前提。",
    ],
  },
  {
    id: "interview-director-morishita",
    title: "专访森下千秋：我拍的不是道德的答案，而是犹豫的过程",
    date: "2025-09-14",
    category: "深度访谈",
    excerpt:
      "在《雨夜的家书》与《海的告解》之后，森下千秋谈创作方法、表演调度，以及为什么她从不给角色安排救赎。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20an%20empty%20film%20director%20chair%20and%20a%20script%20on%20a%20wooden%20floor%20in%20soft%20window%20light%2C%20muted%20brown%20and%20cool%20grey%20tones%2C%20quiet%20cinematic%20mood%2C%20no%20text&width=800&height=450&seq=news-03&orientation=landscape",
    tags: ["深度访谈", "导演", "创作"],
    content: [
      "采访安排在森下千秋的工作室，桌上摊着一叠手写分镜。她先把话说在前面：「我不太会回答关于主题的问题，我更愿意谈方法。」",
      "谈到《雨夜的家书》里那场读信的戏，她说自己只给了演员两个指令：不要哭，不要看对方。「因为真实的遗憾往往没有出口，它只会让人变得很安静。」",
      "对于「为什么不给角色救赎」的提问，她的回答很直接：「因为救赎是一种叙事上的偷懒。它让观众感到舒服，但现实里大多数伦理问题只是被时间稀释，并没有被解决。」",
      "她也提到剪辑对伦理表达的影响：一个反打镜头的取舍，可能就决定了观众站在谁那一边。「所以我在剪辑台上常常要提醒自己，不要替观众做判断。」",
      "新作仍在筹备中，她只透露会继续讨论「照料」这个主题。「照护是伦理最具体的样子，它每天都在发生，而且无法伪装。」",
    ],
  },
  {
    id: "care-ethics-on-screen",
    title: "照护作为一种伦理：日式家庭剧中的「谁在照顾谁」",
    date: "2025-08-30",
    category: "文化解析",
    excerpt:
      "从《镜中的母亲》到《檐下三人》，照护关系正在成为日本伦理影视最重要的议题之一。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20folded%20white%20linen%20and%20a%20cup%20of%20tea%20on%20a%20low%20wooden%20shelf%20in%20a%20Japanese%20home%2C%20soft%20morning%20light%2C%20muted%20cream%20and%20warm%20brown%20tones%2C%20no%20text&width=800&height=450&seq=news-04&orientation=landscape",
    tags: ["文化解析", "照护", "代际"],
    content: [
      "照护是伦理最具体的形态：它由重复的琐事构成，没有高潮，也无法被一次性完成。日本伦理影视近年对此表现出持续兴趣，原因之一是老龄化社会让这类经验变得普遍。",
      "《镜中的母亲》把照护者与被照护者的权力关系拍得极为细致。当母亲开始把女儿认作年轻时的自己，女儿同时获得了两种身份：照顾者与记录者。她因此拥有了定义母亲形象的权力，而这本身就是一种伦理负担。",
      "《檐下三人》则把照护扩展到非血缘关系。重组家庭的秩序不是靠宣言建立的，而是靠记得对方的忌口、在雨天收衣服这些动作累积起来。",
      "值得注意的是，这些作品普遍拒绝把照护浪漫化。疲惫、怨怼与愧疚同时存在，人物常常在深夜独自崩溃。正是这种不美化，让照护劳动获得了应有的可见度。",
      "当影视作品愿意呈现照护的消耗，它也在提出一个公共问题：这份劳动究竟应该由家庭内部消化，还是应由社会共同承担。",
    ],
  },
  {
    id: "autumn-lineup-2025",
    title: "2025 秋季伦理题材片单：五部值得留意的虚构新作",
    date: "2025-08-18",
    category: "行业动态",
    excerpt:
      "从家庭和解到制度反思，本期片单收录五部风格各异的新作，并附上观看前的背景提示。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20a%20stack%20of%20film%20canisters%20and%20a%20small%20notebook%20on%20a%20dark%20wooden%20shelf%2C%20warm%20low%20light%2C%20muted%20navy%20and%20amber%20tones%2C%20cinematic%20still%20life%2C%20no%20text&width=800&height=450&seq=news-05&orientation=landscape",
    tags: ["行业动态", "片单", "新作"],
    content: [
      "本季度的伦理题材作品呈现出明显的「内向化」趋势：大冲突减少，人物更多在封闭空间里对话。以下是五部值得留意的虚构新作。",
      "《灯下的约定》以家族仪式为线索，把分散的家人重新聚到同一张桌前。它对团聚不做煽情处理，反而强调尴尬与疏离，因而最后的亮灯时刻格外有分量。",
      "《逆光的餐桌》几乎是双人剧，全片九成时间在室内。导演用逆光把夫妻关系视觉化：只能看见轮廓，看不清表情。",
      "《玻璃温室的冬天》关注「照料陌生人」这一较少被讨论的伦理情境。温室玻璃透明却隔绝，与当代都市人的孤独状态高度契合。",
      "此外，《山的证言》与《空白的一页》分别从土地与记忆两个方向切入，前者讨论共同体的边界，后者追问谁有资格定义过去。",
    ],
  },
  {
    id: "why-silence-matters",
    title: "沉默如何成为一种叙事：伦理影视中的停顿美学",
    date: "2025-07-29",
    category: "文化解析",
    excerpt:
      "在伦理题材作品中，最重要的信息常常不在台词里。本文分析停顿、空镜与留白如何承担判断的重量。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20an%20empty%20tatami%20room%20with%20a%20single%20cushion%20and%20afternoon%20light%20through%20a%20paper%20screen%2C%20minimal%20composition%2C%20muted%20beige%20and%20deep%20navy%20shadows%2C%20no%20text&width=800&height=450&seq=news-06&orientation=landscape",
    tags: ["文化解析", "叙事", "影像语言"],
    content: [
      "伦理题材最难处理的不是冲突，而是冲突之后的沉默。人物在做出选择后如何面对自己，往往无法用台词表达。",
      "日本伦理影视发展出一套成熟的停顿语法：人物说完一句话后，镜头会多停留两到三秒；对话被打断时，画面切到无关的空镜；重要的决定常常发生在画外。",
      "这种处理把判断的责任交还给观众。当影片不告诉你谁对谁错，你就必须自己完成意义的闭合。",
      "《我不曾说过的话》把沉默推到极致。父子始终没有真正对话，全部情感通过留言机里的呼吸与迟疑传递。声音成为唯一的在场证明。",
      "停顿不是空白，而是被压缩的时间。它让观众有机会意识到：在现实生活中，我们也常常在沉默里做决定。",
    ],
  },
  {
    id: "streaming-and-ethics-content",
    title: "流媒体时代，伦理题材为何反而更需要「慢」",
    date: "2025-07-08",
    category: "行业动态",
    excerpt:
      "当平台算法偏好强刺激，伦理题材的生存空间在哪里？几位从业者给出了相似的答案：把节奏还给人。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20a%20dim%20room%20with%20a%20laptop%20screen%20glow%20and%20a%20cup%20of%20tea%20on%20a%20wooden%20desk%20at%20night%2C%20blue%20grey%20ambient%20light%2C%20muted%20tones%2C%20no%20text&width=800&height=450&seq=news-07&orientation=landscape",
    tags: ["行业动态", "流媒体", "产业"],
    content: [
      "流媒体改变了观看方式，也改变了叙事节奏。平台数据倾向于前几分钟必须抓住注意力，这对慢热的伦理题材构成压力。",
      "但多位从业者认为，伦理题材恰恰不能顺应这种节奏。「如果前五分钟就给出结论，观众就没有参与判断的空间，」一位制片人这样说。",
      "应对方式之一是调整结构：把长片拆成更短的章节，用章节标题替代强钩子，让「慢」变得可预期。",
      "另一种方式是强化空间感。当叙事节奏放缓，观众对场景的注意力会转向细节——一只碗、一道门、一段走廊，反而更容易被记住。",
      "最终，这类作品的竞争力不在于信息密度，而在于观看后仍留在观众心里的那部分。它需要时间，也需要被允许拥有时间。",
    ],
  },
  {
    id: "reunion-kitchen-scene",
    title: "一场厨房戏的十种拍法：《檐下三人》的空间调度笔记",
    date: "2025-06-21",
    category: "剧情解析",
    excerpt:
      "厨房是家庭伦理剧最常出现的空间。本文以《檐下三人》为例，拆解空间如何替人物说话。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20a%20small%20Japanese%20kitchen%20with%20wooden%20counter%2C%20hanging%20utensils%20and%20warm%20morning%20light%2C%20muted%20amber%20and%20deep%20brown%20tones%2C%20quiet%20cinematic%20mood%2C%20no%20text&width=800&height=450&seq=news-08&orientation=landscape",
    tags: ["剧情解析", "空间调度", "檐下三人"],
    content: [
      "厨房是家庭伦理剧的默认战场。它狭小、功能明确，人在其中必须侧身让路，身体距离天然接近，冲突也因此更容易发生。",
      "《檐下三人》有一场长达六分钟的厨房戏：三个人同时准备早餐，动线不断交叠。导演没有安排任何争吵，但观众能感到紧张，因为空间本身就在挤压人物。",
      "关键在于机位。摄影机被放在厨房门口，始终不进入内部，形成一个观察者的视角。观众像站在走廊上的第四个人，看得见却插不上手。",
      "当孩子终于把碗放到错误的位置，冲突爆发。这个动作在别的场景里微不足道，但在积累六分钟后，它成了压垮秩序的最后一根稻草。",
      "空间调度的高明之处在于：它让伦理冲突变成物理事实。你不需要解释谁越界了，观众从身体的避让里已经读到了全部。",
    ],
  },
  {
    id: "fictional-archive-method",
    title: "我们如何整理一份虚构的影视档案：编辑方法说明",
    date: "2025-06-02",
    category: "站点说明",
    excerpt:
      "本站收录的作品、人物与机构均为虚构示例。本文说明编辑标准、解析框架与内容边界。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20index%20cards%20and%20a%20pen%20in%20an%20open%20wooden%20drawer%20with%20soft%20window%20light%2C%20muted%20cream%20and%20navy%20tones%2C%20orderly%20archive%20mood%2C%20no%20text&width=800&height=450&seq=news-09&orientation=landscape",
    tags: ["站点说明", "编辑", "版权"],
    content: [
      "为保证演示内容的完整性与安全性，本站所有影视作品、导演、演员、机构与新闻事件均为虚构示例，不对应任何真实作品或人物。",
      "收录标准包括三条：是否以伦理关系为核心议题；是否提供了可讨论的处境而非单一结论；是否在叙事或影像语言上有可分析之处。",
      "解析框架分为四个层次：剧情事实、人物动机、伦理处境、文化背景。我们尽量避免在解析中给出道德裁决，而是呈现多方立场与其代价。",
      "所有评分与热度均为演示数据，不代表真实评价。站内不提供播放、下载或任何形式的资源链接。",
      "如对内容框架有建议，欢迎通过关于页面的联系方式与我们交流。",
    ],
  },
  {
    id: "sound-of-home",
    title: "家的声音：环境音如何建构伦理空间",
    date: "2025-05-16",
    category: "文化解析",
    excerpt:
      "水声、碗碟、电车与蝉鸣——当配乐退场，环境音成为家庭关系最忠实的记录者。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20a%20traditional%20Japanese%20engawa%20porch%20with%20wind%20chimes%20and%20green%20garden%20beyond%2C%20soft%20summer%20light%2C%20muted%20green%20and%20warm%20wood%20tones%2C%20no%20text&width=800&height=450&seq=news-10&orientation=landscape",
    tags: ["文化解析", "声音设计", "空间"],
    content: [
      "越来越多伦理题材作品选择不使用配乐。原因并不复杂：配乐会替观众规定情绪，而伦理题材恰恰需要保留观众自主判断的空间。",
      "当音乐退场，环境音的重要性被放大。水龙头的声音可以说明谁在洗碗，走廊的脚步声可以说明谁在犹豫，远处的电车则标记出时间的流逝。",
      "《白瓷之隙》几乎完全依赖环境音。碗碟碰撞的清脆与沉闷区分了不同的情绪状态，这种细微差别比任何台词都更精确。",
      "《蝉鸣时节》则用蝉声建立季节感。声音的密度随剧情推进而变化，在关键抉择时刻反而减弱，形成一种不自觉的屏息。",
      "家的声音之所以动人，是因为它无法伪装。你可以对家人说谎，但关门的声音会暴露你的情绪。",
    ],
  },
];